import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable } from 'rxjs';
import { UtilsService } from './utils.service';

@Injectable({
  providedIn: 'root'
})

export class CategoryService {
  emptyGuid = "00000000-0000-0000-0000-000000000000";

  constructor(private http: HttpClient, private utils: UtilsService) {
  }

  getCategoryDataByGuid(guid: any,pageName:string, isGuid: boolean): Observable<any> {
    let body: any = {}
    body['guidId']=isGuid?guid:this.emptyGuid,
    body['landingPageName']=pageName
    let url = this.utils.apiUrl + 'LandingPage/GetINBTLandingDetails';
    return this.http.post(url, body, { headers: this.utils.skipInterceptorHeaders }).pipe(catchError(this.utils.processError.bind(this)));
  }

  getSolarCategoryDataByGuid(guid: any,pageName:string, isGuid: boolean): Observable<any> {
    let body: any = {}
    body['guidId']=isGuid?guid:this.emptyGuid,
    body['landingPageName']=pageName
    let url = this.utils.apiUrl + 'LandingPage/GetSolarCategoryLandingDetails';
    return this.http.post(url, body, { headers: this.utils.skipInterceptorHeaders }).pipe(catchError(this.utils.processError.bind(this)));
  }

  bookConsultation(body:any) {
    let url = this.utils.apiUrl + 'CustomerConsultation/SaveCustomerConsultation';
    return this.http.post(url, body, { headers: this.utils.skipInterceptorHeaders }).pipe(catchError(this.utils.processError.bind(this)));
  }
}